export default __webpack_public_path__ + "static/media/header-icon2.abc5ef08.svg";